










































































































import {
  Component,
  Vue,
  namespace,
  Watch,
  mixins,
} from 'nuxt-property-decorator'
import Vue2TouchEvents from 'vue2-touch-events'
import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiDeleteForeverOutline,
} from '@mdi/js'
import { NuxtAppOptions } from '@nuxt/types'
import { IStyle } from '~/assets/interfaces/classes'
import { COMPARE_EXTEND_API } from '~/assets/config/api-path'
import {
  ICompareCategory,
  ICompareExtendItem,
  ICompareExtendItemParam,
  ICompareItem,
} from '~/assets/interfaces/compare'
import { debounce } from '~/assets/functions/debounce'
import { IMeta } from '~/assets/interfaces/meta'
import MixinGeneral from '~/assets/mixins/general'
import ComponentFormCheckbox from '~/components/form/checkbox.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentLoadingDots from '~/components/loading/dots.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentCompareItem from '~/components/compare/compare-item.vue'

Vue.use(Vue2TouchEvents)

const compareStore = namespace('compare')
const pageStore = namespace('page')
const siteStore = namespace('site')

@Component({
  watchQuery: ['page'],
  components: {
    ComponentPageContent,
    ComponentFormButtonIcon,
    ComponentIcon,
    ComponentFormButton,
    ComponentLoadingDots,
    ComponentTypographyH1,
    ComponentFormCheckbox,
    ComponentCompareItem,
  },
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
})
export default class pagePersonalIndex extends mixins(MixinGeneral) {
  private async asyncData({ $axios }: { $axios: NuxtAppOptions }) {
    const response = await $axios.$get(COMPARE_EXTEND_API)
    return response
  }

  @compareStore.Getter('itemsQuantity') private itemsQuantity!: number
  @compareStore.State('items') private compareItems!: ICompareItem[]
  @siteStore.Getter('getFixedHeaderHeight')
  readonly fixedHeaderHeight!: number | null

  $refs!: Vue['$refs'] & {
    items: HTMLElement
    itemsWrapper: HTMLElement
    product: Vue
  }

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null

  private styleMobileGrid!: IStyle

  private icons = {
    mdiDeleteForeverOutline,
    mdiChevronRight,
    mdiChevronLeft,
  }

  private get classWrapper() {
    return {
      [this.$style.wrapper]: true,
      [this.styleMobileGrid.container]: this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private onlyDifferences = true
  private categories: ICompareCategory[] = []
  private items: ICompareExtendItem[] = []
  private params: any[] = []
  private isLoading = false

  private onlyDifferencesChange() {
    this.onlyDifferences = !this.onlyDifferences
  }

  private get paramsFilter() {
    if (this.onlyDifferences) {
      return this.params.filter((item) => {
        return !!item.difference
      })
    }
    return this.params
  }

  private async getItems() {
    this.isLoading = true
    const response = await this.$axios.$get(COMPARE_EXTEND_API)
    this.categories = response.categories
    this.items = response.items
    this.params = response.params
    this.isLoading = false
  }

  private async getItemsByCategory(categoryId: number) {
    if (!this.isLoading) {
      this.isLoading = true
      const response = await this.$axios.$get(
        `${COMPARE_EXTEND_API}/${categoryId.toString()}/`
      )
      this.categories = response.categories
      this.items = response.items
      this.params = response.params
      this.isLoading = false
      this.slide = 0
    }
  }

  private async deleteCategory() {
    const activeCategory = this.categories.find(
      (e: ICompareCategory) => e.active
    )
    if (!this.isLoading && (activeCategory || activeCategory === 0)) {
      this.isLoading = true
      await this.$axios.$delete(
        `${COMPARE_EXTEND_API}/${activeCategory.id.toString()}/`
      )
      this.isLoading = false
      await this.getItems()
      this.slide = 0
    }
  }

  @Watch('compareItems', { deep: true })
  private async compareItemsHandler() {
    await this.getItems()
  }

  private productParam(params: ICompareExtendItemParam[], id: number) {
    if (params) {
      const param = params.find((item) => {
        return item.id === id
      })
      if (param) {
        return param.title
      }
    }
    return '—'
  }

  private updated() {
    this.calculateDebounce(this)
  }

  private productWidth = 0
  private productHeight = 0

  private calculateDebounce = debounce((that: pagePersonalIndex) => {
    if (Array.isArray(that.$refs.product)) {
      const first = that.$refs.product[0].$el as HTMLElement
      that.productWidth = first.offsetWidth
      that.productHeight = first.offsetHeight
    }
  }, 250)

  private created() {
    this.setMeta({
      h1: 'Сравнение',
      title: 'Сравнение товаров',
    })
  }

  private mounted(): void {
    if (process.client) {
      window.addEventListener('resize', this.listenerCalculateDebounce)

      const interval = setInterval(() => {
        if (this.$refs.itemsWrapper && this.$refs.items) {
          this.startScrollPosition =
            window.pageYOffset +
            this.$refs.itemsWrapper.getBoundingClientRect().bottom -
            this.fixedFilterOffset
          this.itemsWrapperStyle = {
            height: `${this.$refs.items.clientHeight}px`,
          }
          clearInterval(interval)
        }
      }, 250)

      window.addEventListener('scroll', () => {
        if (!this.isMakingFixed) {
          window.requestAnimationFrame(() => {
            this.makeFixed()
            this.isMakingFixed = false
          })
          this.isMakingFixed = true
        }
      })
    }
  }

  private beforeDestroy(): void {
    window.removeEventListener('resize', this.listenerCalculateDebounce)
    window.removeEventListener('scroll', () => {})
  }

  private listenerCalculateDebounce() {
    this.calculateDebounce(this)
  }

  private slide = 0

  private get maxSlide() {
    return this.$device.isMobileOrTablet
      ? this.items.length - 2
      : this.items.length - 8
  }

  private prevSlide() {
    this.slide = this.slide - 1
    if (this.slide < 0) {
      this.slide = 0
    }
  }

  private nextSlide() {
    this.slide = this.slide + 1
    if (this.slide > this.maxSlide) {
      this.slide = this.maxSlide
    }
  }

  private isFixed = false
  private startScrollPosition = 0
  private itemsWrapperStyle = {}
  private isMakingFixed = false

  private get fixedFilterOffset() {
    return this.fixedHeaderHeight || 0
  }

  private makeFixed() {
    this.isFixed = window.scrollY > this.startScrollPosition
  }

  private compareItemLoadingHandler(value: boolean) {
    this.isLoading = value
  }

  private get itemsClass() {
    return {
      [this.$style.items]: true,
      [this.$style.fixed]: this.isFixed,
    }
  }

  private get itemsInnerClass() {
    return {
      [this.$style.itemsInner]: true,
      [this.$style.fixed]: this.isFixed,
    }
  }

  private get itemsStyle() {
    return { top: `${this.fixedFilterOffset}px` }
  }

  private classCategoryItem(active: boolean) {
    return {
      [this.$style.categoriesItem]: true,
      [this.$style.active]: active,
    }
  }

  private get classNavigationButtonNext() {
    return {
      [this.$style.navigationButton]: true,
      [this.$style.active]: this.slide + 1 <= this.maxSlide,
    }
  }

  private get classNavigationButtonPrev() {
    return {
      [this.$style.navigationButton]: true,
      [this.$style.active]: this.slide - 1 >= 0,
    }
  }

  private gutter = 24

  private get translateX() {
    const X = this.slide * (this.productWidth + this.gutter)
    return {
      transform: `translateX(${-1 * X}px)`,
    }
  }
}
